import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { iconoirArchery, iconoirBookStack, iconoirUser } from '@ng-icons/iconoir';
import { TranslatePipe } from '@ngx-translate/core';
import { GetDemoComponent } from '@pyg-shared/get-demo/get-demo.component';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
  imports: [TranslatePipe, GetDemoComponent, NgIcon],
  providers: [provideIcons({ iconoirArchery, iconoirBookStack, iconoirUser })],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutComponent {}
